<template>
  <div class="SouhuoH5NewuserinfoBox">
    <div class="SouhuoH5Newuserinfo">
      <div class="topPart">
        <van-image round class="header" fit="cover" :src="userInfo.HeadPortraitUrl ? userInfo.HeadPortraitUrl : require('@/assets/icon/defaultHead.png')" />
        <div class="topLeftPart">
          <div class="name">
            {{ userInfo.Nick | filterNick }}
          </div>
          <div class="limitTagList" v-if="userInfo.IsBuyLimit || userInfo.IsTALimit">
            <template v-if="userInfo.IsTALimit">
              <div v-if="userInfo.LimitDayNumber" class="limitTag" @click="violationTagClick($event)">
                <span class="iconfont icon-jinzhi"></span>
                <span class="oneRow">提现限制至{{ userInfo.TALimitRemoveDate | formatOverTime }}</span>
              </div>
              <div v-else class="limitTag" @click="violationTagClick($event)"><span class="iconfont icon-jinzhi"></span>提现限制中</div>
            </template>
            <template v-if="userInfo.IsBuyLimit">
              <div v-if="userInfo.BuyLimitDayNumber" class="limitTag" @click="violationTagClick($event)">
                <span class="iconfont icon-jinzhi"></span>
                <span class="oneRow">限制购买至{{ userInfo.BuyLimitRemoveDate | formatOverTime }}</span>
              </div>
              <div v-else class="limitTag" @click="violationTagClick($event)"><span class="iconfont icon-jinzhi"></span>限制购买中</div>
            </template>
          </div>
          <div class="tip" v-else>与搜货一起省省省~</div>
        </div>
      </div>
      <div class="bottomPart">
        <div class="item" @click="userLevel">
          <div class="itemCon">
            <div class="label gold">{{ userInfo.UserLevel | filterLevel }}</div>
            <div class="desc">
              <span>会员等级</span>
              <van-icon name="arrow" class="arrowIcon" />
            </div>
          </div>
        </div>
        <div class="item" @click="freeCard">
          <div class="itemCon">
            <div class="label">
              {{ userInfo.GetQtyNoUsed || 0 }}
              <soho-badge :number="waitGetFreeCard" :needAddSymbol="true" class="numTag"></soho-badge>
            </div>
            <div class="desc"><span>免单卡数</span><van-icon name="arrow" class="arrowIcon" /></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Icon } from 'vant'
export default {
  name: 'SouhuoH5Newuserinfo',
  props: {
    waitGetFreeCard: {
      type: Number,
      default: 0
    },
    userInfo: {
      type: Object,
      require: true,
      default: () => {
        return {}
      }
    }
  },
  components: {
    'van-icon': Icon
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    goUserInfo() {
      this.$emit('goUserInfo')
    },
    userLevel() {
      this.$emit('userLevel')
    },
    freeCard() {
      this.$emit('freeCard')
    },
    violationTagClick(e) {
      e.stopPropagation()
      this.$emit('violationTagClick')
    }
  },
  filters: {
    filterNick(val) {
      if (!val) return '----'
      if (val.length > 5) return val.substring(0, 5) + '...'
      return val
    },
    formatOverTime(val) {
      if (!val) return '----'
      return moment(val).format('M月D日')
    },
    filterLevel(val) {
      if (val === 1) return 'V1'
      else if (val === 2) return 'V2'
      else if (val === 3) return 'V3'
      else return 'V-'
    }
  }
}
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}
.SouhuoH5NewuserinfoBox {
  position: relative;
  width: 100%;
  overflow: visible;
  &::before {
    position: absolute;
    top: -1px;
    left: 50%;
    content: '';
    width: 110%;
    height: 100px;
    transform: translateX(-50%);
    background-color: #000;
    border-bottom-right-radius: 30px;
    border-bottom-left-radius: 30px;
  }
}
.SouhuoH5Newuserinfo {
  position: relative;
  display: flex;
  flex-direction: column;
  width: vw(355);
  height: 142px;
  background-color: #fff;
  margin: 0 auto;
  border-radius: 8px;
  padding: 0 17px;
  box-sizing: border-box;
  .topPart {
    display: flex;
    // align-items: center;
    border-bottom: 1px solid #f2f2f2;
    padding: 9px 0;
    .header {
      width: 60px;
      height: 60px;
      margin-right: 8px;
    }
    .topLeftPart {
      margin-top: 8px;
      .name {
        font-size: 15px;
        font-weight: 700;
        color: #2e2e2e;
        margin-bottom: 4px;
      }
      .tip {
        font-size: 13px;
        color: #888888;
      }
      .limitTagList {
        display: flex;
        align-items: center;
        .limitTag {
          display: flex;
          align-items: center;
          font-size: 12px;
          background-color: #feeeee;
          color: #f26161;
          margin-right: 4px;
          padding: 0 8px;
          height: 22px;
          border-radius: 11px;
          .iconfont {
            position: relative;
            top: 0;
            font-size: 13px;
            margin-right: 4px;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
  .bottomPart {
    display: flex;
    align-items: center;
    flex: 1;
    .item {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-around;
      .itemCon {
        display: flex;
        flex-direction: column;
        align-items: center;
        .label {
          position: relative;
          font-weight: 700;
          font-size: 18px;
          line-height: 1em;
          margin-bottom: 2px;
          margin-bottom: 6px;
          color: #333333;
          .numTag {
            position: absolute;
            top: -8px;
            // margin-left: 4px;
            right: 0;
            transform: translateX(120%);
          }
          &.gold {
            color: #d7b36e;
          }
        }
        .desc {
          display: flex;
          align-items: center;
          position: relative;
          font-size: 13px;
          color: #888888;
          // background-color: pink;
          span {
            line-height: 1em;
          }
          .arrowIcon {
            position: absolute;
            font-size: 12px;
            top: 50%;
            right: -12px;
            transform: translate(0, -50%);
            // background-color: #0094FF;
          }
        }
      }
    }
  }
}
</style>
